import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`

export const AppFooterText = styled.p`
  font-weight: 300;
  font-size: 14px;
  line-height: 20.8px;
  margin-top: 4px;
  color: #fff;
  @media (max-width: 767.98px) {
    display: none;
  }
`

export const ColHeader = styled.h3`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #fff;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.65);
  padding-bottom: 6px;
  margin-bottom: 12px;
  @media (max-width: 767.98px) {
    margin-bottom: 4px;
    font-size: 14px;
  }
`

export const ColList = styled.ul`
  list-style-type: none;
  padding-left: 0;
`

export const ColListSocial = styled.ul`
  list-style-type: none;
  padding-left: 0;
  @media (max-width: 575px) {
    display: flex;
    margin-top: 10px;
  }
`

export const ColListItem = styled.li`
  margin-bottom: 4px;
  > a {
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: rgba(255, 255, 255, 0.65);
    text-decoration: none;
    font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande',
      sans-serif;
    &:hover {
      color: rgba(236, 117, 81, 0.7);
    }
    @media (max-width: 767.98px) {
      font-size: 12.25px;
    }
  }
`

export const ColListSocialItem = styled.li`
  margin-bottom: 4px;
  > a {
    display: flex;
    align-items: center;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: rgba(255, 255, 255, 0.65);
    text-decoration: none;
    font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande',
      sans-serif;
    &:hover {
      color: rgba(236, 117, 81, 0.7);
    }
    @media (max-width: 767.98px) {
      font-size: 12.25px;
    }
    @media (max-width: 575px) {
      margin-right: 16px;
    }
  }
`

export const SocialText = styled.div`
  margin-left: 12px;
  line-height: 24px;
  @media (max-width: 575px) {
    display: none;
  }
`

export const SignoffList = styled.ul`
  display: flex;
  list-style-type: none;
  padding-left: 0;
  @media (max-width: 767.98px) {
    margin-right: 0;
    flex-wrap: wrap;
    margin-bottom: 0;
    > li:last-child > a {
      margin-right: 0;
    }
  }
`

export const SignoffListEnd = styled.ul`
  display: flex;
  list-style-type: none;
  padding-left: 0;
  justify-content: flex-end;
  @media (max-width: 575px) {
    justify-content: flex-start;
  }
  @media (max-width: 767.98px) {
    margin-right: 0;
    flex-wrap: wrap;
    margin-bottom: 0;
    > li:last-child > a {
      margin-right: 0;
    }
  }
`

export const SignoffListItem = styled.li`
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #fff;
  text-decoration: none;
  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande',
    sans-serif;
  @media (max-width: 767.98px) {
    font-size: 12px;
  }
  > a {
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #fff;
    text-decoration: none;
    font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande',
      sans-serif;
    margin-right: 22px;
    &:hover {
      color: rgba(236, 117, 81, 0.7);
    }
    @media (max-width: 767.98px) {
      font-size: 12px;
      margin-right: 6px;
    }
  }
  &:last-child > a {
    margin-right: 0;
  }
`

export const CentricLogo = styled.img`
  max-width: 150px;
  margin-bottom: 1em;
  margin-top: -7px;
`

export const AppFooterContracts = styled.div`
  margin-bottom: 8px;
  > .ant-typography {
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.65);
    &:first-child {
      color: #fff;
    }
    @media (max-width: 575px) {
      &:last-child {
        font-size: 11px;
      }
    }
  }
  &:last-child {
    @media (max-width: 767.98px) {
      margin-bottom: 30px;
    }
  }
`
